import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AumicoCoreProvider } from '@modeso/aumico-lib-core-fe';
import type { ITextSnippetDTO } from '@modeso/types__aumico-lib-annualreport-be';
import Debug from 'debug';
import type { Observable } from 'rxjs';
import { finalize } from 'rxjs';
import { RoutesUtil } from '../utils/routes.util';

const debug = Debug('modeso:aumico-annualreport:AumicoTextSnippetService');

const HTTP_OPTIONS = {
    headers: new HttpHeaders({
        'Content-Type': 'application/json',
    }),
};

@Injectable({
    providedIn: 'root',
})
export class AumicoTextSnippetService {
    constructor(
        private readonly http: HttpClient,
        private readonly coreProvider: AumicoCoreProvider,
        private readonly routesUtil: RoutesUtil,
    ) {}

    public createTextSnippet$(textSnippet: ITextSnippetDTO): Observable<ITextSnippetDTO> {
        debug('create new text snippet');
        const url = this.routesUtil.getTextSnippetRoute();
        this.coreProvider.dispatchBlockingRequest('createTextSnippet$');
        return this.http
            .post<ITextSnippetDTO>(url, textSnippet)
            .pipe(finalize(() => this.coreProvider.dispatchBlockingRequestEnd('createTextSnippet$')));
    }

    public getAllTextSnippets(): Observable<ITextSnippetDTO[]> {
        debug('get all text snippets');
        const url = this.routesUtil.getAllTextSnippetsRoute();
        this.coreProvider.dispatchBlockingRequest('getAllTextSnippets$');
        return this.http
            .get<ITextSnippetDTO[]>(url)
            .pipe(finalize(() => this.coreProvider.dispatchBlockingRequestEnd('getAllTextSnippets$')));
    }

    public deleteTextSnippets$(textSnippetsIds: string[]): Observable<void> {
        debug('deleteTextSnippets called');

        const url = this.routesUtil.deleteTextSnippetsRoute();
        this.coreProvider.dispatchBlockingRequest('deleteTextSnippets$');

        return this.http
            .put<void>(
                url,
                {
                    ids: textSnippetsIds,
                },
                HTTP_OPTIONS,
            )
            .pipe(finalize(() => this.coreProvider.dispatchBlockingRequestEnd('deleteTextSnippets$')));
    }

    public updateTextSnippet$(textSnippet: ITextSnippetDTO): Observable<ITextSnippetDTO> {
        const url = this.routesUtil.updateTextSnippetsRoute(textSnippet._id);
        this.coreProvider.dispatchBlockingRequest('updateTextSnippet$');
        return this.http
            .put<ITextSnippetDTO>(url, { textSnippet: textSnippet }, HTTP_OPTIONS)
            .pipe(finalize(() => this.coreProvider.dispatchBlockingRequestEnd('updateTextSnippet$')));
    }

    public getTextSnippetById$(id: string): Observable<ITextSnippetDTO> {
        const url = this.routesUtil.getTextSnippetByIdRoute(id);
        this.coreProvider.dispatchBlockingRequest('getTextSnippetById$');
        return this.http
            .get<ITextSnippetDTO>(url)
            .pipe(finalize(() => this.coreProvider.dispatchBlockingRequestEnd('getTextSnippetById$')));
    }
}
